import { OmitStrict } from "@amx/ux-twoui-utils";
import React from "react";
import { FeatureLayoutProps } from "../Feature.types";
import { FeatureContentShimmer } from "../FeatureContent/FeatureContentShimmer/FeatureContentShimmer";
import { FeatureImageShimmer } from "../FeatureImage/FeatureImageShimmer/FeatureImageShimmer";
import { FeatureLayout } from "../FeatureLayout/FeatureLayout";

export type FeatureShimmerProps = OmitStrict<FeatureLayoutProps, "contentSlot" | "imageSlot">;

export const FeatureShimmer: React.FC<FeatureShimmerProps> = (props) => {
    return (
        <FeatureLayout
            {...props}
            imageSlot={(
                <FeatureImageShimmer height={props.height} />
            )}
            contentSlot={(
                <FeatureContentShimmer />
            )}
        />
    );
};
